import {
    timeline as tlStyles
} from "../styles/ChallanStyles";
import { DotIcon } from "./SvgIcons";
export const Timeline = ({ steps }) => (
    <div style={tlStyles.container}>
        {steps.map((step, i) => (
            <div key={i} style={tlStyles.step}>
                {i < steps.length - 1 && <div style={tlStyles.line(step.state)} />}
                <div style={tlStyles.dot(step.state)}>
                    <DotIcon state={step.state} />
                </div>
                <div style={tlStyles.stepLabel(step.state)}>{step.label}</div>
                <div style={tlStyles.stepDate(step.state)}>{step.date}</div>
            </div>
        ))}
    </div>
);
